import React, { createContext, useContext, useState } from 'react';

const ShowTaskEditOptionsContext = createContext();

export const ShowTaskEditOptionsProvider = ({ children }) => {
  const [showTaskEditOptions, setShowTaskEditOptions] = useState(false);

  return (
    <ShowTaskEditOptionsContext.Provider
      value={{ showTaskEditOptions, setShowTaskEditOptions }}
    >
      {children}
    </ShowTaskEditOptionsContext.Provider>
  );
};

export const useShowTaskEditOptionsContext = () =>
  useContext(ShowTaskEditOptionsContext);
